import { Subject, Observable, of } from 'rxjs';
import * as moment from 'moment';
import { ECalendarsOperationType } from '../actions/calendars.actions';

export class CalendarsOperations {

    public static workingTimeSchemaOperationsWorker(idUser:number, workingTimeSchema: IWorkingTimeSchema[], 
        schema: IWorkingTimeSchema,
        calendarsDic?: {[key: string]: IWorkingTimeSchema},
        operation: ECalendarsOperationType = ECalendarsOperationType.ADD): Observable<IWorkingTimeSchema[]> {

        const _schema = { ...schema, idUser };
        const _calendarsDict = { ...calendarsDic };
        const _nonWorkingDays = CalendarsOperations.getRangeOfDates(_schema.fromDate, _schema.toDate);
        const affectedCalendarsRank: IWorkingTimeSchema[] = [];
        const _workingTimeSchema = workingTimeSchema.map((item) => {
            return {...item}
        });

        if (operation === ECalendarsOperationType.MODIFY) {
            _schema.idWorkingTimeData = -1;
            (Object.keys(_calendarsDict)).forEach((day) => {
                if ( _calendarsDict[day].toDate === _schema.toDate && _calendarsDict[day].fromDate === _schema.fromDate) {
                    delete _calendarsDict[day];
                }
            });
            const toDeleteIndex = _workingTimeSchema.findIndex((schemaItem) => {
                return schemaItem.fromDate === _schema.fromDate || schemaItem.toDate === _schema.toDate
            });
            if (toDeleteIndex >= 0) {
                _workingTimeSchema.splice(toDeleteIndex, 1);
            }
        }

        _nonWorkingDays.forEach((day: string) => {
            if (_calendarsDict[day]) {
                const newAffectedCalendar = _calendarsDict[day];
                let isNew = true;
                affectedCalendarsRank.forEach((schemaItem) => {
                    if (schemaItem.fromDate === newAffectedCalendar.fromDate && schemaItem.toDate === newAffectedCalendar.toDate) {
                        isNew = false;
                    }
                });
                if (isNew) {
                    affectedCalendarsRank[affectedCalendarsRank.length] =  { ...newAffectedCalendar } ;
                }
            }
        });

        if (affectedCalendarsRank.length > 0) {
            (affectedCalendarsRank).forEach((affectedCRank: IWorkingTimeSchema) => {

                const affectedIndex = _workingTimeSchema.findIndex((item) => {
                    return (item.fromDate === affectedCRank.fromDate && item.toDate === affectedCRank.toDate);
                });
              
                _workingTimeSchema.splice(affectedIndex, 1);
                
                const affectedRank = {
                    from: moment(affectedCRank.fromDate).toDate(),
                    to: moment(affectedCRank.toDate).toDate()
                };

                const newRank = {
                    from: moment(_schema.fromDate).toDate(),
                    to:  moment(_schema.toDate).toDate()
                }
                
                const applyResize = !(newRank.from <= affectedRank.from && newRank.to >= affectedRank.to);

                if(applyResize) {
                    if ((newRank.from > affectedRank.from && newRank.from <= affectedRank.to) && newRank.to >= affectedRank.to) {
                        const newToDayAffected = (moment(_schema.fromDate).subtract(1, 'd')).toDate();
                        affectedCRank.toDate = CalendarsOperations.getStringDate(newToDayAffected);
                        _workingTimeSchema[_workingTimeSchema.length] = affectedCRank;
                    } 
                    if ((newRank.from <= affectedRank.from && newRank.from < affectedRank.to) && newRank.to < affectedRank.to) {
                        const newFromDayAffected = (moment(_schema.toDate).add(1, 'd')).toDate();
                        affectedCRank.fromDate = CalendarsOperations.getStringDate(newFromDayAffected);
                        _workingTimeSchema[_workingTimeSchema.length] = affectedCRank;
                    }

                    if (newRank.from > affectedRank.from && newRank.to < affectedRank.to) {
                        const toLowerRank =  (moment(_schema.fromDate).subtract(1, 'd')).toDate();
                        const fromTopRank = (moment(_schema.toDate).add(1, 'd')).toDate();
                        const lowerRank: IWorkingTimeSchema = {
                            ...affectedCRank,
                            fromDate: CalendarsOperations.getStringDate(affectedRank.from),
                            toDate: CalendarsOperations.getStringDate(toLowerRank),
                            idWorkingTimeData: -1
                        };

                        const topRank: IWorkingTimeSchema = {
                            ...affectedCRank,
                            fromDate: CalendarsOperations.getStringDate(fromTopRank),
                            toDate: CalendarsOperations.getStringDate(affectedRank.to),
                            idWorkingTimeData: -1
                        };

                        _workingTimeSchema[_workingTimeSchema.length] = lowerRank;
                        _workingTimeSchema[_workingTimeSchema.length] = topRank;
                    }
                }
            });
        }
        if (operation !== ECalendarsOperationType.RESET) {
            _workingTimeSchema[_workingTimeSchema.length] = _schema;
        }
        return of(_workingTimeSchema);
    }

    public static  getCalendarDic = function(customUserCalendar: Array<IWorkingTimeSchema>) {
        const calendarDic = {};
        _.each(customUserCalendar, (workingTimeSchema: IWorkingTimeSchema) => {
          _.each(CalendarsOperations.getRangeOfDates(workingTimeSchema.fromDate, workingTimeSchema.toDate), (date: string) => {
            calendarDic[date] = workingTimeSchema;
          })
        });
        return calendarDic;
    }
    
    public static getRangeOfDates(fromDate: string, toDate: string): Array<string> {
        const dates = [];

        const startDate = new Date(fromDate);
        const endDate = new Date(toDate);
        // Strip hours minutes seconds etc.
        let currentDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate()
        );

        while (currentDate <= endDate) {
            dates.push(moment(currentDate).format('YYYY-MM-DDTHH:mm:ss'));

            currentDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1, // Will increase month if over range
            );
        }

        return dates;
    };
    
    public static getStringDate(date: Date): string {
        return moment(date).format('YYYY-MM-DDT00:00:00');
    }

    public static getStringTimestamp(date: Date): string {
        return moment(date).format('1900-01-01THH:mm:ss');
    }

    public static getEmptyWorkingTimeSchema(isWorking = false) {
      return {
            fromDate: '',
            toDate: '',
            idWorkingTimeData: -1,
            idUser: null,
            weekDay: '',
            isWorking,
            fromTime1: null,
            toTime1: null,
            fromTime2: null,
            toTime2: null,
            fromTime3: null,
            toTime3: null,
            fromTime4: null,
            toTime4: null,
            fromTime5: null,
            toTime5: null
          };
    }
}
